import axios from "axios";

const API_DOMAIN = window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN;

const getAuthHeaders = async (auth0: any) => {
  try {
    const token = await auth0.getAccessTokenSilently();
    return { headers: { Authorization: `Bearer ${token}` } };
  } catch (e) {
    throw e;
  }
};

// Get Filtered Ideas
export const getFilteredIdeas = async (
  filters: any,
  sort: { [name: string]: 1 | -1 },
  limit: number,
  skip: number,
  tabName: string,
  auth0: any,
  archived: boolean
): Promise<{ totalCount: number; ideas: any[] }> => {
  try {
    const config = await getAuthHeaders(auth0);
    const url = `${API_DOMAIN}/ideas/filters_query`;
    const response = await axios.post(
      url,
      { filters, sort, limit, skip, tabName, archived },
      config
    );
    return response.data;
  } catch (e: any) {
    console.error("Error getting filtered ideas:", e);
    throw e;
  }
};

// Get Idea Columns
export const getIdeaColumns = async (auth0: any): Promise<any[]> => {
  try {
    const config = await getAuthHeaders(auth0);
    const url = `${API_DOMAIN}/ideas/config/columns`;
    const response = await axios.get(url, config);
    return response.data.ideaColumns;
  } catch (e: any) {
    console.error("Error getting idea columns:", e);
    throw e;
  }
}; 